import { createWebHistory, createRouter } from "vue-router";
import MyMap from "../views/MyMap.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: MyMap,
  },
];

const router = createRouter({
  // Use import.meta.env.BASE_URL to get the base path from Vite config
  // This ensures the router works correctly when deployed to a subdirectory
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;